module.exports = __webpack_public_path__ + "static/media/laura.db467c1e.png";